/* Bande défilante du site (Santavya, 25/10/2026, accord de Cédric « oui bande ») : le texte « OFFRES DU MOMENT »
   est remplacé par l'offre en cours du calendrier Notion (assets/santavya-evenements.json, tools/evenements_export.py),
   avec sa vraie date de fin — plus de « se termine à minuit » répété chaque jour (fausse urgence, L121-4).
   27/10/2026 (Cédric : « que cette barre aussi soit esthétiquement modifiée selon l'événement en cours ») : pendant un
   événement, la bande prend la DA de l'événement (fond, couleur d'accent, icône) — mêmes couleurs que le bandeau
   « offre du jour » des pages produits (product-dna/santavya/p0025/atelier/page/build_template.py, table T).
   Hors événement : la bande noire d'origine, inchangée. Test : ?p25ev=<clé> (ex. ?p25ev=noel). */
(function () {
  // Bande toujours visible (Cédric, 27/10/2026 : « qu'il reste tout le temps en haut, comme le header ») :
  // la bande colle en haut de l'écran et le header collant se range juste en dessous, sur tout le site.
  (function colle() {
    var tk = document.querySelector('.horizontal-ticker');
    var sec = tk && tk.closest('.shopify-section');
    if (!sec) return;
    var st = document.createElement('style');
    function h() { document.documentElement.style.setProperty('--sv-tk', sec.offsetHeight + 'px'); }
    st.textContent = '#' + sec.id + '{position:sticky;top:0;z-index:6}' +
      '.shopify-section-header-sticky{top:var(--sv-tk,0px)!important}';
    document.head.appendChild(st); h();
    window.addEventListener('resize', h);
  })();
  var MARK = 'OFFRES DU MOMENT';
  var url = document.currentScript && document.currentScript.getAttribute('data-ev');
  if (!url) return;
  function z(x) { return ('0' + x).slice(-2); }
  var n = new Date(), td = n.getFullYear() + '-' + z(n.getMonth() + 1) + '-' + z(n.getDate());
  var CC = (window.Shopify && Shopify.country) || 'FR';
  var DA = { // fond, texte, accent, icône
    halloween: ['linear-gradient(90deg,#1b1b1f,#3a1d06 50%,#1b1b1f)', '#fff', '#ff7a00', '🎃'],
    bf: ['#000', '#fff', '#ffd400', '⚡'],
    noel: ['linear-gradient(90deg,#5c0b11,#b3141f 50%,#5c0b11)', '#fff', '#f5d27a', '🎄'],
    nouvelan: ['linear-gradient(90deg,#1b1b3a,#3b2a6b 50%,#1b1b3a)', '#fff', '#f5d27a', '✨'],
    soldes: ['linear-gradient(90deg,#a61e1e,#e03131 50%,#a61e1e)', '#fff', '#fff3bf', '🏷️'],
    valentin: ['linear-gradient(90deg,#8a1c45,#d6336c 50%,#8a1c45)', '#fff', '#ffd6e5', '❤️'],
    fete: ['linear-gradient(90deg,#16305e,#1C4DA5 50%,#16305e)', '#fff', '#ffd43b', '🎁'],
    printemps: ['linear-gradient(90deg,#1b6e2e,#2f9e44 50%,#1b6e2e)', '#fff', '#d3f9d8', '🌸'],
    ete: ['linear-gradient(90deg,#0b7285,#1098ad 50%,#0b7285)', '#fff', '#ffe066', '☀️'],
    rentree: ['linear-gradient(90deg,#16305e,#1C4DA5 50%,#16305e)', '#fff', '#ffd43b', '🎒'],
    automne: ['linear-gradient(90deg,#7c2d12,#c2410c 50%,#7c2d12)', '#fff', '#fed7aa', '🍂'],
    hiver: ['linear-gradient(90deg,#0f2440,#1e3a5f 50%,#0f2440)', '#fff', '#d0ebff', '❄️']
  };
  function habille(k, txt) {
    var d = DA[k]; if (!d) return;
    var st = document.createElement('style');
    st.textContent = '.horizontal-ticker{background:' + d[0] + '!important;color:' + d[1] + '!important}' +
      '.horizontal-ticker .horizontal-ticker__item{color:' + d[1] + '!important}' +
      '.horizontal-ticker .p25-bev{color:' + d[2] + '!important;font-weight:800}' +
      '.horizontal-ticker .horizontal-ticker__item:before{content:"•";color:' + d[2] + ';margin-right:14px;opacity:.9}';
    document.head.appendChild(st);
    document.querySelectorAll('.horizontal-ticker__item').forEach(function (p) {
      if (p.textContent.trim() === txt) { p.innerHTML = '<span aria-hidden="true">' + d[3] + '</span> <span class="p25-bev"></span>'; p.lastChild.textContent = txt; }
    });
  }
  fetch(url).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (L) {
    var e = null;
    for (var i = 0; i < L.length; i++) {
      var x = L[i];
      if (x.st <= td && td <= x.en && (!x.p.length || x.p.indexOf(CC) >= 0 || (x.p.indexOf('FR') >= 0 && ['FR', 'CH', 'BE'].indexOf(CC) < 0))) { e = x; break; }
    }
    var q = (location.search.match(/[?&]p25ev=([a-z]+)/) || [])[1];
    if (q) e = { k: q, lb: 'Test ' + q, en: td, fin: null, p: [] };
    if (!e) return;
    var fin = (e.fin || e.en).slice(0, 10).split('-');
    var txt = (e.lb + ' jusqu’au ' + fin[2] + '/' + fin[1]).toUpperCase();
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), t, hits = [];
    while ((t = w.nextNode())) { if (t.nodeValue.trim().toUpperCase() === MARK) hits.push(t); }
    hits.forEach(function (h) { h.nodeValue = h.nodeValue.replace(/\S.*\S/, txt); });
    habille(e.k, txt);
  }).catch(function () {});
})();
